import { render } from "./Fractions.vue?vue&type=template&id=64f34065&scoped=true&ts=true"
import script from "./Fractions.vue?vue&type=script&lang=ts"
export * from "./Fractions.vue?vue&type=script&lang=ts"

import "./Fractions.vue?vue&type=style&index=0&id=64f34065&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\jonatan\\Documents\\Repos\\milva-online\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64f34065"]])

export default __exports__